import request from '@/utils/request'
import URL from '@/api/baseUrl'
export default class User {
  /**
 * 登录
 * @param {} data
 */
  static token(data = {}) {
    return request.post(`${URL.auth}/token/login`, null, {
      data: data,
      headers: { 'Authorization': 'Basic dmlwOnZpcA==', 'content-type': 'application/x-www-form-urlencoded' }
    })
  }
  /**
   * 登出
   * @param {} data
   */
  static logout(data = {}) {
    return request.post(`${URL.auth}/token/logout`, data)
  }

  /**
   * 获取用户信息
   * @param {} data
   */
  static getUserInfo(data = {}) {
    return request.get(`${URL.system}/user/getInfo`, data)
  }

  /**
   * 首次登录修改密码
   * @param {} data
   */
  static firstLoginUpdate(data = {}) {
    return request.put(`${URL.vip}/profile/firstLoginUpdate`, data)
  }

  /**
   * 获取路由
   * @param {} data
   */
  static getRouters(data = {}) {
    return request.get(`${URL.system}/menu/getRouters`, {
      type: 3,
    })
  }


  /**
   * 查询服务列表
   */
  static getInfoByCode(data = {}) {
    return request.get(`${URL.comBasic}/bas-public-params/getInfoByCode`, data)
  }
}

